<template>
  <div class="container">
    <div class="stadium_tip">
      ※ 会员支持预约的酒店名单非固定酒店，会员可提前线上预约。<br />
      ※ 由于季节变化/酒店健身中心经营/各地疫情防控等原因，酒店可能会不定期上新或下架，请注意关注首页公告。<br />
      ※ 五星级酒店为保证服务质量，每天为限额预订，请提前预约游泳健身服务。
    </div>
    <div v-for="(item,index) in city" class="stadium">
      <div class="stadium_block">
        <div class="stadium_title">{{item}}</div>
        <div  class="stadium_item_bo">
          <div class="stadium_item" v-for="(item_stadium,index_stadium) in stadium" v-show="item_stadium.city==item">
            <div class="stadium_item_item">
              {{item_stadium.name}}
              <div class="stadium_item_item_div" v-if="item_stadium.is_black_vip==1 && vip_level!='b1'&& vip_level!='a'&& vip_level!='A'&& vip_level!='D'&& vip_level!='d'&& vip_level!='v4'&& vip_level!='v5'&& vip_level!='v6'&& vip_level!='F'&& vip_level!='f'"></div>
            </div>

            <!-- <div class="stadium_item_item_div" v-if="item_stadium.is_black_vip==1 && vip_level!='b1'&& vip_level!='a'&& vip_level!='A'&& vip_level!='D'&& vip_level!='d'&& vip_level!='v4'&& vip_level!='v5'&& vip_level!='v6'&& vip_level!='F'&& vip_level!='f'"></div> -->
            <!-- <img src="../../assets/images/backvip_stadium.png" /> -->
          </div>
        </div>

        <!-- <div v-else class="stadium_item_bo">
          <div class="stadium_item" v-for="(item_stadium,index_stadium) in stadium" v-show="item_stadium.city==item">
            <div v-if="item_stadium.is_black_vip!=1" class="stadium_item_item">
              {{item_stadium.name}}
            </div>
          </div>
        </div> -->

      </div>

    </div>
    <!-- <div class="stadium_bottom_tips">注：以上酒店中，黑金专享酒店仅供黑金会员预约，其余酒店均可供全部会员预约。</div> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        city:[],
        vip_level:'',//此字段与小程序会员字段等同
      }
    },
    created() {
      document.title="酒店列表"
      // console.log(this.$route.params.type)
      this.vip_level=this.$route.params.type
      // if(this.$route.params.type=='4'||this.$route.params.type==4){
      //   this.title='黑金会员'
      // }else if(this.$route.params.type=='3'||this.$route.params.type==3){
      //   this.title='钻石会员'
      // }else if(this.$route.params.type=='2'||this.$route.params.type==2){
      //   this.title='铂金会员'
      // }else if(this.$route.params.type=='1'||this.$route.params.type==1){
      //   this.title='黄金会员'
      // }else{
      //   this.title='黑金会员'
      // }
      this.FLLoadStadiumList()
    },
    watch: { },
    mounted() { },
    methods: {
      unique(arr) {
        return Array.from(new Set(arr))
      },
      FLLoadStadiumList(){
        var $this = this
        let param = { }
        var qs = require('qs');
        let url = this.api.userApi.wxExport_flStadiumLists
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.code==0) {
						
						if(result.data.stadiums.length>0){
							result.data.stadiums.map((item,index)=>{
								if(item.stadium_id==100052){
									item.is_black_vip=1
								}
							})
						}

            $this.stadium=result.data.stadiums
            var citytemp=[]
            for (var i = 0; i < result.data.stadiums.length; i++) {
              citytemp.push(result.data.stadiums[i].city)
            }
            // console.log(citytemp)
            // console.log($this.unique(citytemp))
            $this.city=$this.unique(citytemp)
          }
        }).catch((error) => {
          console.warn(error)
        })
      },
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  ::-webkit-scrollbar{width:0*@vm_base;height: 0;}
  .container{
    // padding-bottom: 20*@vm_base;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 0 60*@vm_base 0;
    &::-webkit-scrollbar{width:0*@vm_base;height: 0;}
    // &::-webkit-scrollbar-thumb { //滑块部分
    //   border-radius: 12*@vm_base;
    //   background-color: #444054;
    // }
  }
  .stadium_tip{
    width: 100%;
    padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
    font-size: 24*@vm_base;
    font-weight: 500;
    color: #666666;
    line-height: 1.8;

    line-height: 1.75;
  }
  .stadium_bottom_tips{
    width: 100%;
    padding: 20*@vm_base 32*@vm_base 20*@vm_base 32*@vm_base;
    font-size: 26*@vm_base;
    font-weight: 600;
    color: #333333;
    line-height: 1.8;
  }
  .stadium{
    width: 100%;
    padding: 40*@vm_base 20*@vm_base 0 20*@vm_base;
    .stadium_block{
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0*@vm_base 10*@vm_base 20*@vm_base 0*@vm_base rgba(0, 0, 0, 0.1);
      border-radius: 10*@vm_base;
      // margin-bottom: 40*@vm_base;
    }
    .stadium_title{
      width: 100%;
      padding: 40*@vm_base 0 20*@vm_base 40*@vm_base;
      background: #FFFFFF;
      border-radius: 10*@vm_base 10*@vm_base 0 0;
      font-size: 36*@vm_base;
      font-weight: bold;
      color: #000000;
      border-bottom: 1*@vm_base solid #E7E7E7;
    }
    .stadium_item_bo{
      padding:26*@vm_base 40*@vm_base;
    }
    .stadium_item{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      // border: 1px solid red;

      font-size: 32*@vm_base;
      font-weight: 400;
      color: #000000;
      .stadium_item_item{
        width: 100%;
        height: 56*@vm_base;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      img{
        width: 137*@vm_base;
        margin-left: 19*@vm_base;
      }
      .stadium_item_item_div{
        width: 137*@vm_base;
        margin-left: 19*@vm_base;
        height: 56*@vm_base;
        // border: 1px solid red;
        background-image: url('../../assets/images/backvip_stadium.png');
        background-position: left 13*@vm_base;
        background-repeat: no-repeat;
        background-size: 100% auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vip/frstadiumslists.vue